// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"904":"ac7649be","3114":"f80e4908","4396":"09b1b763","9635":"da13ac3c","9986":"3b4ca820"}[chunkId] + ".chunk.css";
};